import http from "../../../../services/http-common";

class CourtesyService {
  getAll(offset: string, limit: string, params: any): any {
    return http.get(`/courtesy/all`, {
      params: params,
    });
  }

  getClients() {
    return http.get(`courtesy/clients`);
  }

  getClient(id: any, type: string, filterParams: string) {
    return http.get(`courtesy/client/${id}`, {
      params: { type, filterParams },
    });
  }

  getClientHimSelf() {
    return http.get(`courtesy/client/him`);
  }

  getClientsLens(id: any): any {
    return http.get(`courtesy/clients/lens/${id?.id_Customer}`);
  }

  insert(params: any) {
    return http.post(`courtesy/insert`, params);
  }

  deactivate(idCourtesyList: number, quantity: number, reason: string) {
    return http.post(`courtesy/lists/${idCourtesyList}/deactivate`, {
      quantity,
      reason,
    });
  }

  getDeactivationHistory(idCourtesyList: number) {
    return http.get(`courtesy/lists/${idCourtesyList}/deactivation-history`);
  }
}

export default new CourtesyService();
